import TabMui from '@mui/material/Tab';
import TabsMui from '@mui/material/Tabs';
import styled from 'styled-components';

export const Tabs = styled(TabsMui)`
  &.MuiTabs-root {
    & > .MuiTabs-scroller {
      .MuiTabs-indicator {
        background-color: #333333;
      }
      .MuiTabs-flexContainer {
        border-bottom: 2px rgba(29, 29, 29, 0.28) solid;
      }
    }

    .Mui-selected {
      background-color: transparent;
    }
  }
`;

export const Tab = styled(TabMui)`
  min-width: 20%;
  &.MuiTab-root {
    text-transform: none;
    color: #828282;

    &.Mui-selected {
      color: #282828;
    }
  }
`;

export const Image = styled.img`
  width: 100%;
  height: 350px;
  object-fit: cover;
  display: block;

  @media screen and (max-width: 425px) {
    height: 130px;
  }
`;
